import { useEffect, useState } from 'react';
import './Header.css';

const NAV_LINKS = [
  { href: '#inicio', label: 'Início' },
  { href: '#sobre', label: 'Quem Somos' },
  { href: '#servicos', label: 'Serviços' },
  { href: '#diferenciais', label: 'Diferenciais' },
  { href: '#contato', label: 'Contato' },
];

function getInitialTheme() {
  try {
    return localStorage.getItem('tsb-theme') === 'light' ? 'light' : 'dark';
  } catch (error) {
    return 'dark';
  }
}

function Header() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem('tsb-theme', theme);
    } catch (error) {
      // Sem persistência quando o navegador bloqueia armazenamento local.
    }

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
      themeColor.setAttribute('content', theme === 'dark' ? '#000000' : '#ffffff');
    }
  }, [theme]);

  useEffect(() => {
    const navbar = document.getElementById('mainNavbar');
    const onScroll = () => {
      if (window.scrollY > 50) {
        navbar.classList.add('navbar-scrolled');
      } else {
        navbar.classList.remove('navbar-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <>
      <div className="top-bar d-none d-md-block">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="top-bar-info">
              <span className="top-bar-tagline">
                Agilidade, <strong>Excelência</strong> e Compromisso
              </span>
            </div>
            <div className="top-bar-info">
              <a href="mailto:comercial@trsilvabueno.com.br">
                comercial@trsilvabueno.com.br
              </a>
              <span className="mx-3">|</span>
              <a href="tel:+5541999912971">(41) 9 9991-2971</a>
            </div>
          </div>
        </div>
      </div>

      <nav
        id="mainNavbar"
        className={`navbar navbar-expand-lg fixed-top tsb-navbar ${theme === 'dark' ? 'navbar-dark' : 'navbar-light'}`}
        aria-label="Navegação principal"
      >
        <div className="container">
          <a className="navbar-brand" href="#inicio">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo_white.png`}
              alt="Tr Silva Bueno Transportes e Logística"
              width="200"
              height="50"
              loading="eager"
              className="brand-logo brand-logo-dark"
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
              alt="Tr Silva Bueno Transportes e Logística"
              width="200"
              height="50"
              loading="eager"
              className="brand-logo brand-logo-light"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Abrir menu"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {NAV_LINKS.map((link) => (
                <li key={link.href} className="nav-item">
                  <a className="nav-link" href={link.href}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={`Ativar tema ${theme === 'dark' ? 'claro' : 'escuro'}`}
              aria-pressed={theme === 'light'}
            >
              <span className="theme-toggle-icon" aria-hidden="true">
                {theme === 'dark' ? '☀' : '☾'}
              </span>
              <span className="theme-toggle-text">
                {theme === 'dark' ? 'Claro' : 'Escuro'}
              </span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
